/* ===========================================================
 * 
 *   Navigation Controller.
 * 
 *   Provides the navigation functionality, including
 *    - response menu toggle
 *    - accessible submenus via tabbing
 *    - touch device listeners
 * 
 * ===========================================================*/

( function() {
    
    var previousParent, container, button, menu, body, links, i, len;

	/**
	 * Determine if an element is a child of another element
     * 
     * @param {string} search_text
     * @param {string} search_text
     * 
	 */
    function isDescendant(parent, child) {
        var node = child.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
   }

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this.parentElement;
	
        // On li elements toggle the class .focus.
        if ( 'li' === self.tagName.toLowerCase() ) {
            if ( -1 === self.className.indexOf( 'focus' ) ) {
                self.className += ' focus';
            }

            else {
                self.blur();
            }
        }
    }
    
    /**
	 * Unset the current focus
     * 
     * @param {event} e
	 */
	function toggleFocusUnset( e ) {

        //  Define the el loosing focus
        var blurEl = e.srcElement.parentNode;

        setTimeout( function(){

            //  Define the element gaining focus
            currentFocus = document.activeElement.parentNode;

            //  If the new element is not a nav item, go ahead and 
            //  unfocus the previous one
            if ( -1 === currentFocus.className.indexOf( 'menu-item' ) ) {
                blurEl.className = blurEl.className.replace( ' focus', '' );
                return;
            }

            //  If they are both top level menu items, go ahead and 
            //  unfocus the previous one
            if ( -1 !== currentFocus.className.indexOf( 'menu-item-top' ) && 
                 -1 !== blurEl.className.indexOf( 'menu-item-top' ) 
            ){
                blurEl.className = blurEl.className.replace( ' focus', '' );
                return;
            }

            //  If they are both sub level menu items, go ahead and 
            //  unfocus the previous one
            if ( -1 !== currentFocus.className.indexOf( 'menu-item-child' ) && 
                 -1 !== blurEl.className.indexOf( 'menu-item-child' ) 
            ){
                blurEl.className = blurEl.className.replace( ' focus', '' );
                return;
            }

            //  If the new item is a direct desendant of the previous one, 
            //  leave the previous one focused - but remember if for later
            if( isDescendant(blurEl, currentFocus ) ) {
                previousParent = blurEl
                return;
            }

            //  Otherwise, hide the previously shown parent element
            if (previousParent) {
                previousParent.className = previousParent.className.replace( ' focus', '' );
            }

        }, 40 );
    }
    
    /**
	 * Init the navigation controller
	 */
    var init = function() {

        //  Get the navigation container
        container = document.getElementById( 'site-navigation' );
        if ( ! container ) {
            return;
        }

        //  Get the toggle button
        button = container.getElementsByTagName( 'button' )[0];
        if ( 'undefined' === typeof button ) {
            return;
        }

        //  Get the menu object
        menu = container.getElementsByTagName( 'ul' )[0];
        if ( 'undefined' === typeof menu ) {
            return;
        }

        //  Get the page body
        body = document.getElementsByTagName("body")[0];
        if ( 'undefined' === typeof body ) {
            return;
        }

        //  Get the page body
        html = document.getElementsByTagName("html")[0];
        if ( 'undefined' === typeof html ) {
            return;
        }

        // Hide menu toggle button if menu is empty and return early.
        if ( 'undefined' === typeof menu ) {
            button.style.display = 'none';
            return;
        }

        //  Set the aria attribute
        menu.setAttribute( 'aria-expanded', 'false' );

        //  Add the menu class if missing
        if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
            menu.className += ' nav-menu';
        }

        //  Listen for the menu toggle button click
        button.onclick = function( e ) {
            
            //  If already toggled, hide the menu
            if ( -1 !== container.className.indexOf( 'toggled' ) ) {
                container.className = container.className.replace( ' toggled', '' );
                button.setAttribute( 'aria-expanded', 'false' );
                menu.setAttribute( 'aria-expanded', 'false' );
                button.classList.remove('active');
                body.classList.remove('nav-on');
                html.classList.remove('nav-on');
            } 
            
            //  Or show the menu
            else {
                container.className += ' toggled';
                button.setAttribute( 'aria-expanded', 'true' );
                menu.setAttribute( 'aria-expanded', 'true' );
                button.classList.add('active');
                body.classList.add('nav-on');
                html.classList.add('nav-on');
            }
        };

        // Get all the link elements within the menu.
        links    = menu.getElementsByTagName( 'a' );

        // Each time a menu link is focused or blurred, toggle focus.
        for ( i = 0, len = links.length; i < len; i++ ) {
            links[i].addEventListener( 'focus', toggleFocus, true );
            links[i].addEventListener( 'blur', toggleFocusUnset, true );
            links[i].addEventListener( 'click', toggleFocus, true );
        }
    };
    
	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
	// ( function( container ) {
	// 	var touchStartFn, i,
	// 		parentLink = container.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// 	if ( 'ontouchstart' in window ) {
	// 		touchStartFn = function( e ) {
	// 			var menuItem = this.parentNode, i;

	// 			if ( ! menuItem.classList.contains( 'focus' ) ) {
	// 				e.preventDefault();
	// 				for ( i = 0; i < menuItem.parentNode.children.length; ++i ) {
	// 					if ( menuItem === menuItem.parentNode.children[i] ) {
	// 						continue;
	// 					}
	// 					menuItem.parentNode.children[i].classList.remove( 'focus' );
	// 				}
	// 				menuItem.classList.add( 'focus' );
	// 			} else {
	// 				menuItem.classList.remove( 'focus' );
	// 			}
	// 		};

	// 		for ( i = 0; i < parentLink.length; ++i ) {
	// 			parentLink[i].addEventListener( 'touchstart', touchStartFn, false );
	// 		}
	// 	}
    // }( container ) );
    
    //  Start the navigation controller
    init();

} )();
